export const slugToName = {
  all: "All",
  blinds: "Blinds",
  zebrablinds: "Zebra Blinds",
  verticalblinds: "Vertical Blinds",
  rollerblinds: "Roller Blinds",
  romanblinds: "Roman Blinds",
  bambooblinds: "Bamboo Blinds",
  venetianblinds: "Venetian Blinds",
  ripplecurtains: "Ripple Curtains",
  doublecurtains: "Double Curtains",
  completedcurtains: "Readymade Curtains",
  interiordesigns: "Interior Designs",
  wallpapersandwallstickers: "Wallpapers & Wall Stickers",
  cushionpillowsandbedsheets: "Cushion, Pillows & Bed Sheets",
};

export const nameToSlug = Object.fromEntries(
  Object.entries(slugToName).map(([slug, name]) => [name, slug])
);

export const mainCategories = [
  "All",
  "Blinds",
  "Ripple Curtains",
  "Double Curtains",
  "Readymade Curtains",
  "Interior Designs",
];

export const blindSubCategories = [
  "Zebra Blinds",
  "Vertical Blinds",
  "Roller Blinds",
  "Roman Blinds",
  "Bamboo Blinds",
  "Venetian Blinds",
];

export const blindSubCategorySlugs = blindSubCategories.map(
  (name) => nameToSlug[name]
);
